import React from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { userInfoState } from '@bo-recoil/common/user/atom';

const UserInfo = styled(FlexBox)`
  width: fit-content;
  align-items: center;
`;
const UserWrapper = () => {
  const userInfo = useRecoilValue(userInfoState);

  return (
    <>
      <UserInfo gap="8px">
        <TextBox weight="700">
          {userInfo?.userName || '사용자명'}
          {userInfo?.jobGroupName ? `(${userInfo?.jobGroupName})` : ''}
        </TextBox>
      </UserInfo>
    </>
  );
};

export default UserWrapper;
